export const HEATRESOURCESPANEL_LOAD_DATA = 'HEATRESOURCESPANEL_LOAD_DATA';
export const HEATRESOURCESPANEL_DATA_SUCCESS = 'HEATRESOURCESPANEL_DATA_SUCCESS';
